var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":function($event){_vm.show_alert = false}}},[_c('b-alert',{staticClass:"position-fixed fixed-bottom m-2 rounded-0 toast-alert",attrs:{"variant":_vm.variant,"dismissible":""},model:{value:(_vm.show_alert),callback:function ($$v) {_vm.show_alert=$$v},expression:"show_alert"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }